import qs from 'qs'
import { generateRedirectParams } from '@/utils/redirect'
import { Dropdown, Avatar, message } from 'antd'
import { useMemo } from 'react'
import type { MenuProps } from 'antd'
import {
  CaretDownOutlined,
  LogoutOutlined,
  InsertRowRightOutlined,
  UserOutlined,
  CheckOutlined,
  CloudOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import useGlobalStore from '@/store/useGlobalStore'
import { useFetch } from '@/hooks/useFetch'
import { useLocation, useNavigate } from 'react-router-dom'
import { getUserInfo, loginOut } from '@/api'
import { getStorage, removeStorage, setStorage } from '@/utils/tools'
import { ReactComponent as AvatarUserIcon } from '@/assets/svg/avatar-user.svg'
import { ReactComponent as SuperAdminIcon } from '@/assets/svg/super-admin.svg'
import { HeaderMenuEnum } from '@/config'
import styles from './index.module.less'
import { getCenterAdminUrl } from '@/utils/env'
import { toQueryString } from '@/utils/url'
import { openNewTab } from '@/utils/help'
import { isDebugMode } from '@/utils/syetem'

const AvatarDropdown = () => {
  const currentTenantId = useGlobalStore(s => s.tenantId)
  const currentUser = useGlobalStore(s => s.userInfo)
  const enterprisesList = useGlobalStore(s => s.enterprisesList)
  const resetGlobalStore = useGlobalStore(s => s.resetGlobalStore)
  const { changeEnterprise } = useFetch()
  const navigate = useNavigate()
  const location = useLocation()
  const tenantId = getStorage('tenantId') || ''

  const basicConfigInfo = useGlobalStore(s => s.basicConfigInfo)
  const superAdminTenantId = useMemo(() => {
    return basicConfigInfo?.superAdminTenantId?.split(':')?.[1] ||  ''
  }, [basicConfigInfo])
  const isDefaultTenant = useMemo(() => {
    return basicConfigInfo?.isDefaultEpid && basicConfigInfo?.isSuperAdmin
  }, [basicConfigInfo])

  const handleSelectEnterprise = async (key: any) => {
    // 没有改变直接 return
    if (key === currentTenantId) return
    let epid = key
    if (key === 'personal') {
      epid = null
    }
    changeEnterprise(epid)
  }

  const handleLoginOut = async () => {
    // 使用通用函数生成重定向参数
    const redirectParams = generateRedirectParams(location)
    const params = qs.stringify(redirectParams)
    loginOut().then(() => {
      navigate(`/login?${params}`)
      message.success('已退出登录')
      removeStorage('token')
      // removeStorage('epid')
      // removeStorage('tenantId')
      removeStorage('username')
      resetGlobalStore()
    })
  }
  // console.log('currentUser', currentUser)
  const currentUserName = currentUser?.realName || currentUser?.userName || getStorage('userName') || '--'

  const onMenuClick: MenuProps['onClick'] = event => {
    const { key, keyPath } = event
    if (keyPath.length === 2) {
      if (keyPath[1] === "center") {
        handleSelectEnterprise(key as any)
      }
      if (keyPath[1] === "setting") {
        if (keyPath[0] === 'history') {
          openNewTab('/system/opHistory')
        }
      }
      return;
    }

    if (key === 'logout') {
      handleLoginOut()
      return
    }

    if (key === 'admin') {
      const adminUrl = getCenterAdminUrl();
      const obj = {
        menuId: 'CENTER_WEB',
        form: 'costWeb',
        epid: getStorage('epid'),
        token: getStorage('token')
      }
      const queryString = toQueryString(obj)
      const openUrl = adminUrl + `?${queryString}`
      window.open(openUrl, '_blank')
      
    }

  }

  const selectedKeys = useMemo(() => {
    if (tenantId?.startsWith('U')) {
      return ['personal']
    }
    const key = tenantId.split(':')[1]
    return [key]
  }, [tenantId])

  // const enterprisesOptions = useMemo(
  //   () =>
  //     enterprisesList.map(i => ({
  //       key: i.epid,
  //       label: (
  //         <div style={{ display: 'flex', alignItems: 'center' }} className={styles.labelWrap}>
  //           {i.enterpriseName}
  //           {selectedKeys.includes(`${i.epid}`) ? (
  //             <CheckOutlined className={styles.checkIcon} />
  //           ) : null}
  //         </div>
  //       ),
  //       icon: <InsertRowRightOutlined />,
  //     })),
  //   [enterprisesList, selectedKeys],
  // )

  // const enterprisesOptions = useMemo(
  //   () =>
  //     enterprisesList.map(i => ({
  //       key: i.epid,
  //       label: (
  //         <div style={superAdminTenantId == i.epid ? { display: 'flex', alignItems: 'center', color: '#F0993E' } : { display: 'flex', alignItems: 'center' }} className={styles.labelWrap}>
  //           {`${i.enterpriseName}${superAdminTenantId == i.epid ? '(超级空间)' : ''}`}
  //           {selectedKeys.includes(`${i.epid}`) ? (
  //             <CheckOutlined className={styles.checkIcon} style={superAdminTenantId == i.epid ? {color: '#F0993E'} : {}} />
  //           ) : null}
  //         </div>
  //       ),
  //       icon: superAdminTenantId == i.epid ? <SuperAdminIcon style={{color: '#F0993E'}} /> : <InsertRowRightOutlined />,
  //     })),
  //   [enterprisesList, selectedKeys, basicConfigInfo],
  // )

  const enterprisesOptions = useMemo(() => {
    const {superItem, options} = enterprisesList.reduce((acc, cur) => {
      if (cur.epid == superAdminTenantId) {
        acc.superItem = {
          key: cur.epid,
          label: (
            <div style={{ display: 'flex', alignItems: 'center', color: '#F0993E' }} className={styles.labelWrap}>
              {`${cur.enterpriseName}(超级空间)`}
              {selectedKeys.includes(`${cur.epid}`) ? (
              <CheckOutlined className={styles.checkIcon} style={{color: '#F0993E'}} />
            ) : null}
          </div>            
          ),
          icon: <SuperAdminIcon style={{color: '#F0993E'}} />,
        }
      } else {
        acc.options.push({
          key: cur.epid,
          label: (
            <div style={{ display: 'flex', alignItems: 'center' }} className={styles.labelWrap}>
              {cur.enterpriseName}
              {selectedKeys.includes(`${cur.epid}`) ? (
                <CheckOutlined className={styles.checkIcon} />
              ) : null}
            </div>
          ),
          icon: <InsertRowRightOutlined />,          
        })
      }
      return acc
    }, {superItem: {}, options: []})
    return [superItem, ...options]
  }, [enterprisesList, selectedKeys, superAdminTenantId])

  const menuItems = [
    {
      key: 'center',
      icon: <UserOutlined />,
      label: '用户空间',
      children: [
        // {
        //   key: 'personal',
        //   icon: <UserOutlined />,
        //   // 个人账号姓名较特殊，需要单独处理
        //   label: (
        //     <div style={{ display: 'flex', alignItems: 'center' }} className={styles.labelWrap}>
        //       {currentUserName}
        //       {selectedKeys.includes(`personal`) ? (
        //         <CheckOutlined className={styles.checkIcon} />
        //       ) : null}
        //     </div>
        //   ),
        // },
        ...enterprisesOptions,
      ],
    },
    // {
    //   key: 'settings',
    //   icon: <SettingOutlined />,
    //   label: '个人设置',
    // },
    // {
    //   type: 'divider' as const,
    // },
    ...(isDebugMode() ? [{
      key: 'setting',
      icon: <SettingOutlined />,
      label: '设置',
      children: [{
        key: 'history',
        label: '查看操作历史',
        onClick: () => {
          console.log("history")
          // navigate(HeaderMenuEnum.systemSettings)
        },
      },
      {
        key: 'version',
        label: `版本信息-${process.env.VERSION}`,
      }]
    }] : []), // 使用数组扩展语法
    {
      key: 'admin',
      icon: <CloudOutlined />,
      label: '后台管理',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
    },
  ]

  return (
    <Dropdown
      overlayClassName={styles.container}
      menu={{
        selectedKeys,
        onClick: onMenuClick,
        items: menuItems,
      }}
    >
      <span className={styles.actionWrap}>
        <Avatar size='small' icon={<AvatarUserIcon />} style={{ backgroundColor: '#fff' }} />
        {/* <span className={styles.username}>{currentUserName}</span> */}
        <span className={styles.username} style={isDefaultTenant ? {color: '#F0993E'} : {}}>{currentUserName}</span>
        <CaretDownOutlined className={styles.iconDown} style={isDefaultTenant ? {color: '#F0993E'} : {}}/>
      </span>
    </Dropdown>
  )
}

export default AvatarDropdown
